import {defineSlotRecipe} from '@chakra-ui/react3'

export const ratingsTextRecipe = defineSlotRecipe({
    slots: ['ratingValue', 'ratingCount'],
    base: {
        ratingValue: {display: 'none'},
        ratingCount: {display: 'none'}
    },
    variants: {
        variant: {
            productTile: {
                ratingCount: {
                    display: 'block',
                    textStyle: 'body.xsmall',
                    color: 'text.secondary',
                    ms: 'spacing-8'
                }
            },
            cockpit: {
                ratingCount: {
                    display: 'block',
                    textStyle: 'body.small',
                    color: 'text.secondary',
                    ms: 'spacing-8'
                }
            },
            pdpSpec: {
                ratingValue: {
                    display: 'block',
                    textStyle: 'heading.xlarge',
                    me: 'spacing-8'
                }
            },
            reviewsModule: {
                ratingValue: {
                    display: 'block',
                    textStyle: 'display.medium',
                    me: 'spacing-10'
                },
                ratingCount: {
                    display: 'block',
                    color: 'text.secondary',
                    textStyle: 'body.small',
                    ms: 'spacing-10'
                }
            },
            review: {}
        }
    }
})
